module.exports = __webpack_public_path__ + "img/u662b.9dcce8fe.jpg";